import { useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { setL2Visible } from 'Deer/slice/DeerNav.slice';
import { useDispatch } from 'react-redux';

import { ReviewCreationIntentDropdown } from './ReviewCreationIntentDropdown';
import { ReviewProcessV2 } from './ReviewProcessV2';
import { ReviewProcessV2Presets } from './ReviewProcessV2Presets';
import useReviewCreationFormId from './hooks/useReviewCreationFormId';

export const ReviewProcessV2Intent = () => {
  const subRoute = useReviewCreationFormId();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setL2Visible({
        isL2Visible: false,
      })
    );
    return () => {
      dispatch(
        setL2Visible({
          isL2Visible: true,
        })
      );
    };
  }, [dispatch]);

  if (subRoute === 'presets') {
    return (
      <Flex flexDir="column" h="calc(100vh - 12px - 8px)">
        <ReviewCreationIntentDropdown />
        <ReviewProcessV2Presets />
      </Flex>
    );
  }

  return (
    <Flex flexDir="column" h="calc(100vh - 12px - 8px)">
      <ReviewCreationIntentDropdown />
      <ReviewProcessV2 />
    </Flex>
  );
};
